import * as React from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { setExtensionsSearchQuery } from '../../actions';
import { useCallback } from 'react';
import { DirectoryStoreState } from '../../types';

export interface ExtensionsSearchBarProps {
  storeId: number;
}

export const ExtensionsSearchBar: React.FC<ExtensionsSearchBarProps> = ({ storeId }) => {
  const { query } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        query: state.extensions[storeId].query,
      }),
      [storeId]
    )
  );

  const dispatch = useDispatch();

  return (
    <div className="extensions-search">
      <input
        type="text"
        value={query}
        onChange={e => dispatch(setExtensionsSearchQuery(storeId, e.target.value))}
      />
    </div>
  );
};
